import {derived, readable} from "svelte/store";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export const modalFade = readable(areModalAnimationsEnabled(), (set) => {
    if (typeof window === "undefined") {
        return;
    }

    const mediaQuery = window.matchMedia?.(REDUCED_MOTION_QUERY);
    const update = () => set(areModalAnimationsEnabled(mediaQuery));

    update();
    mediaQuery?.addEventListener?.("change", update);

    return () => {
        mediaQuery?.removeEventListener?.("change", update);
    };
});

export const modalClassName = derived(modalFade, ($modalFade) => $modalFade ? "" : "modal-no-fade");

function areModalAnimationsEnabled(mediaQuery) {
    if (typeof window === "undefined") {
        return true;
    }

    mediaQuery ??= window.matchMedia?.(REDUCED_MOTION_QUERY);

    if (mediaQuery?.matches) {
        return false;
    }

    return hasTransitionDurationFor("modal fade");
}

function hasTransitionDurationFor(classNames) {
    if (typeof window === "undefined" || typeof document === "undefined" || !document.body) {
        return true;
    }

    const element = document.createElement("div");
    element.className = classNames;
    element.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;";
    document.body.appendChild(element);

    const style = window.getComputedStyle(element);
    const hasTransitionDuration = getTransitionDuration(style.transitionDuration, style.transitionDelay) > 0;
    element.remove();

    return hasTransitionDuration;
}

function getTransitionDuration(transitionDuration, transitionDelay) {
    return Math.max(
        ...transitionDuration.split(",").map((duration) => Number.parseFloat(duration)),
        ...transitionDelay.split(",").map((delay) => Number.parseFloat(delay))
    );
}

export function focusLastModalElement(selector) {
    if (typeof document === "undefined") {
        return;
    }

    const elements = document.querySelectorAll(selector);
    elements.item(elements.length - 1)?.focus();
}

export function handleStaticModalToggle(close) {
    return (event) => {
        if (!event || isStaticModalCloseTrigger(event)) {
            close();
        }
    };
}

function isStaticModalCloseTrigger(event) {
    if (event.type === "keydown") {
        return false;
    }

    const target = event.target;
    return !(target instanceof Element) || Boolean(target.closest(".btn-close"));
}
